export default __webpack_public_path__ + "static/restrooms_showers-8fbc41965cd5f3c092d144eb17ee7cf4.png";